import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { actorLabel, isSystemEvent, isTechnicianActor } from 'utils/auditLabels';
import { ActorAvatar } from './ActorAvatar';
import TechnicianPill from './TechnicianPill';
import type { AdminAuditEvent } from 'api/adminAuditApi';

/** Avatar + name — shared by every row that shows an actor: top-level, import-child and the
 * import parent itself (design §6.4). Italic only applies to a deleted account, never to System. */
export const ActorCell = ({ event }: { event: AdminAuditEvent }) => {
  const { t } = useTranslation();
  const deleted = event.actor === null && !isSystemEvent(event);
  return (
    <div role="cell" className="flex min-w-0 items-center gap-2">
      <ActorAvatar event={event} size="sm" />
      <span className={cn('truncate text-[13px]', deleted && 'italic text-muted-foreground')}>{actorLabel(t, event.actor, event.context)}</span>
      {isTechnicianActor(event.actor) && <TechnicianPill />}
    </div>
  );
};

export default ActorCell;
